const { checkPermission, PermissionsEnum } = require('../utils/permissionsHelper');

export default function({store, redirect, route}) {
	// At the moment, we don't want any of our pages accessible
	// to unauthenticated users. If we ever want to add a Support
	// or FAQ page or some other page that should be visible
	// to all users, we would have to adjust this logic.
	const loggedIn = store.getters['user/isAuthenticated'];
	// console.log('Logged In? ', loggedIn);
	if (!loggedIn && route.path !== '/') {
		// console.log('Not Authenticated');
		return redirect('/');
	}

	// console.log('Route PATH: ', route.path);

	// If the user is authenticated and navigating to '/', redirect
	// them to the protected '/dashboard' page.
	if (loggedIn && route.path === '/') {
		// console.log('Redirecting to dashboard');
		return redirect('/dashboard');
	}

	const user = store.state.user.user;
	if (user && !checkPermission(user, PermissionsEnum.CreateUsers) && route.path === '/admin') {
		return redirect('/dashboard');
	}

	if (user && !user.isConversaEmployee && route.path.startsWith('/conversa')) {
		return redirect('/dashboard');
	}
}
